import e from "./index101.js";
//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/createGetSelector.js
var t = (t) => (n, r) => {
	let i = t.rootSelector || ":root", a = t.colorSchemeSelector, o = a;
	if (a === "class" && (o = ".%s"), a === "data" && (o = "[data-%s]"), a?.startsWith("data-") && !a.includes("%s") && (o = `[${a}="%s"]`), t.defaultColorScheme === n) {
		if (n === "dark") {
			let a = {};
			return e(t.cssVarPrefix).forEach((e) => {
				a[e] = r[e], delete r[e];
			}), o === "media" ? {
				[i]: r,
				"@media (prefers-color-scheme: dark)": { [i]: a }
			} : o ? {
				[o.replace("%s", n)]: a,
				[`${i}, ${o.replace("%s", n)}`]: r
			} : { [i]: {
				...r,
				...a
			} };
		}
		if (o && o !== "media") return `${i}, ${o.replace("%s", String(n))}`;
	} else if (n) {
		if (o === "media") return { [`@media (prefers-color-scheme: ${String(n)})`]: { [i]: r } };
		if (o) return o.replace("%s", String(n));
	}
	return i;
};
//#endregion
export { t as default };

//# sourceMappingURL=index102.js.map